let latestAddedProduct = '';

class MtCartRecommendations extends HTMLElement {
  connectedCallback() {
    this.lifecycle?.abort();
    this.requests?.abort();
    this.lifecycle = new AbortController();
    this.requests = new AbortController();
    this.hidden = true;
    this.output = this.querySelector('[data-cart-recommendations-output]');
    this.layout = this.querySelector('template[data-cart-recommendations-layout]');

    try {
      this.config = JSON.parse(this.querySelector('[data-cart-recommendations-config]').textContent);
      if (!Array.isArray(this.config.cartProducts) || !Array.isArray(this.config.seedProducts)) return;
    } catch {
      return;
    }
    if (!this.output || !this.layout || !this.dataset.url || !this.dataset.sectionId) return;

    const options = { capture: true, signal: this.lifecycle.signal };
    document.addEventListener('variant:add', (event) => {
      const added = event.detail?.items?.find((item) => item.product_id && !item.properties?._mt_reward && !item.gift_card);
      if (added) latestAddedProduct = String(added.product_id);
    }, options);
    // The native drawer replaces this instance after cart events. Cancel its stale work first.
    const invalidate = () => {
      this.requests.abort();
      this.hidden = true;
    };
    document.addEventListener('cart:change', invalidate, options);
    document.addEventListener('cart:refresh', invalidate, options);
    this.load().catch(() => { this.hidden = true; });
  }

  disconnectedCallback() {
    this.lifecycle?.abort();
    this.requests?.abort();
  }

  async load() {
    const controller = this.requests;
    const cartProducts = new Set(this.config.cartProducts.map(String));
    const seeds = [...new Set(this.config.seedProducts.map(String))];
    if (seeds.includes(latestAddedProduct)) {
      seeds.splice(seeds.indexOf(latestAddedProduct), 1);
      seeds.unshift(latestAddedProduct);
    }
    const limit = Math.min(10, Math.max(1, Number(this.dataset.limit) || 4));
    const products = new Map();
    const intent = this.dataset.intent === 'related' ? 'related' : 'complementary';

    // Bound network work for large carts; each request can supply up to ten cards.
    for (const productId of seeds.slice(0, 3)) {
      if (controller.signal.aborted) return;
      try {
        const url = new URL(this.dataset.url, window.location.origin);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set('product_id', productId);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('intent', intent);
        url.searchParams.set('limit', '10');
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin', cache: 'no-store', priority: 'low' });
        if (!response.ok) continue;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.querySelector('mt-cart-recommendations');
        for (const template of source?.querySelectorAll('template[data-cart-recommendation-product]') || []) {
          const id = template.dataset.cartRecommendationProduct;
          if (!id || cartProducts.has(id) || products.has(id) || !template.content.querySelector('.horizontal-product')) continue;
          products.set(id, template);
          if (products.size >= limit) break;
        }
      } catch {
        if (controller.signal.aborted) return;
      }
      if (products.size >= limit) break;
    }

    if (controller.signal.aborted || this.requests !== controller || !this.isConnected || products.size === 0) return;
    const layout = this.layout.content.cloneNode(true);
    const list = layout.querySelector('[data-cart-recommendations-list]');
    for (const template of products.values()) list.append(template.content.cloneNode(true));
    layout.querySelector('[data-cart-recommendations-controls]').hidden = products.size < 2;
    this.hidden = false;
    this.output.replaceChildren(layout);
  }
}

if (!customElements.get('mt-cart-recommendations')) customElements.define('mt-cart-recommendations', MtCartRecommendations);
